const WORKSPACES = {
  'dev-backend.playerdex.app': 'gdlq57o8',
  'core.playerdex.app': 'f5ktqeup',
};
export const INTERCOM_SDK_STATE_EVENT = 'playerdex:intercom-sdk-state';

export function resolveIntercomAppId({ backendUrl, appId } = {}) {
  let hostname;
  try { hostname = new URL(backendUrl).hostname; } catch { return null; }
  const expected = WORKSPACES[hostname];
  if (appId !== undefined && !/^[a-z0-9]{4,32}$/.test(appId)) return null;
  // Never let a DEV build silently contact the production workspace.
  if (expected) return appId === undefined || appId === expected ? expected : null;
  return appId && appId !== 'f5ktqeup' ? appId : null;
}

export function getIntercomAppId() {
  return resolveIntercomAppId({
    backendUrl: process.env.REACT_APP_BASE_URL,
    appId: process.env.REACT_APP_INTERCOM_APP_ID,
  });
}

/** Queue signed boot calls until the matching workspace's SDK finishes loading. */
export function loadIntercomMessenger(appId) {
  if (!appId || appId !== getIntercomAppId()) return false;
  const script = document.getElementById('playerdex-intercom-sdk');
  if (script && script.getAttribute('data-workspace') !== appId) return false;
  if (typeof window.Intercom === 'function') return true;
  if (script) return false;
  const intercom = function () {
    // Before SDK load, shutdown invalidates pending sessions too. Otherwise
    // an obsolete language/identity can boot briefly when the queue replays.
    if (arguments[0] === 'shutdown') intercom.q = [];
    intercom.q.push(arguments);
  };
  // The SDK implicitly boots an anonymous session when its queue holds no
  // boot/shutdown; our later signed boot then runs as an update, which never
  // receives tooltips. Queue a shutdown so the signed boot stays a real boot.
  intercom.q = [['shutdown']];
  window.Intercom = intercom;
  const sdk = document.createElement('script');
  sdk.id = 'playerdex-intercom-sdk';
  sdk.setAttribute('data-workspace', appId);
  sdk.async = true;
  sdk.src = `https://widget.intercom.io/widget/${appId}`;
  const notify = status => window.dispatchEvent(new CustomEvent(INTERCOM_SDK_STATE_EVENT, { detail: { appId, status } }));
  sdk.onload = () => {
    if (document.getElementById(sdk.id) === sdk) notify('ready');
  };
  sdk.onerror = () => {
    const current = document.getElementById(sdk.id) === sdk;
    intercom.q = [];
    if (window.Intercom === intercom) delete window.Intercom;
    sdk.remove();
    if (current) notify('error');
  };
  document.head.appendChild(sdk);
  return true;
}
